export interface UserCommReport {
    uin: number; // QQ号
    to_uin: number; // 被操作者标识ID
    guid: string; // 设备号，android报imei，ios报idfa
    longitude: number; // 经度
    latitude: number; // 纬度
    city_code: string; // 城市ID
    platform: string; // 上报平台类型，IOS、AND、PC、UNKOWN
    client_type: string; // 业务代码,SQ、QZ、UNKOWN
    app_version: string; // 应用版本,如7.3.2_762
    market: string; // 投放市场,如YYB、APP
    qua: string; // 细分版本唯一标识，空间业务专用
    os_version: string; // 操作系统,IOS
    mobile_type: string; // 手机型号，如_iPhone5,2
    ip_addr: string; // 用户ip地址
    network_type: string; // 网络状态,(4G,5G,WIFI,UNKNOW)
    operators: string; // 运营商(YD,LT,DX)
    qimei: string; // qimei字段
    user_tag: { [K: string]: string }; // 用户标识
}

// trace调用链相关信息
export interface TraceInfo {
    trace_id: string; // 调用链起始点生成，调用链每个节点都需要带上trace_id(任何节点都不能漏报)
    trace_num: number; // 调用链起始点为1，调用链每向下延伸+1
    trace_detail: string; // trace的详细信息
    trace_index: string; // trace短字符串
}

// 用户动作相关的信息
export interface ActionInfo {
    oper_time: number; // 按uinxtime格式上报,为action_id触发时间
    action_id: number; // 动作ID
    action_value: number; // 行为值，部分动作需要
    action_attr: number; // 动作属性
}

// 算法实验相关的信息,透传来自后端的信息
export interface RuleInfo {
    test_id: number; // 场景ID
    rule_id: number; // 算法ID
    str_ruleid: string; // 算法ID
}

// Item相关的信息
export interface ItemInfo {
    item_id: string; // action_id的对象
    sub_item_id: Array<string>; // 对应action_id的子对象组，如付费某个appid下的某个道具
    module_id: string; // item所属的模块
    sub_module_id: string; // 子模块
    position_id: string; // 物品在页面或模块上位置id
    rule_info: RuleInfo; // item的算法相关信息
    action_infos: Array<ActionInfo>; // item的动作信息，曝光点击
    trigger_info: string; // trigger信息，透传后台的trigger_info字段
    busi_info: string; // 业务相关的json
    item_type: string; // item的类型，如气泡、字体,透传后台类型
}

// 页面模块相关的信息
export interface PageInfo {
    appid: string; // 业务的appid，用于区分不同的业务
    page_id: string; // 页面ID，确保不能冲突
    item_infos: Array<ItemInfo>; // 页面里面的item信息
}

export interface UserActionReport {
    trace_info: TraceInfo;
    page_info: PageInfo;
    to_uin: number; // 被操作者标识ID
}

export interface UserActionReportReq {
    type: ENUM_USER_ACTION_REPORT_TYPE; // ENUM_USER_ACTION_REPORT_TYPE
    user_comm_report: UserCommReport; // 用户通用信息
    report_infos: Array<UserActionReport>; // 上报内容
}

export interface UserActionReportRsp {
    ret_code: number;
    ret_msg: string;
    trace_details: Array<string>;
}

export enum ENUM_USER_ACTION_REPORT_TYPE {
    RECOM_EFEECT_REPORT = 1, // 推荐效果上报
    VAB_ADV_PLATFORM_REPORT = 2, // 增值广告平台上报
    QQVIP_PAY_REPORT = 3, // 会员支付流水
    QZONEVIP_PAY_REPORT = 4, // 黄钻支付流水
    QQLIVE_BUSI = 8, // QQ直播业务上报
    QQLIVE_COMM = 9 // QQ直播中台上报
}
